// extracted by mini-css-extract-plugin
export var MainContent = "overview-module--MainContent--3XhX_";